import { render, staticRenderFns } from "./psOutQueryRc.vue?vue&type=template&id=48f3c157&scoped=true"
import script from "./psOutQueryRc.vue?vue&type=script&lang=js"
export * from "./psOutQueryRc.vue?vue&type=script&lang=js"
import style0 from "./psOutQueryRc.vue?vue&type=style&index=0&id=48f3c157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3c157",
  null
  
)

export default component.exports